<template>
  <div class="container">
    <div ref="leftMenu" class="left-menu" :style="leftMenuStyle">
      <left-menu
        :project-file-selected-list="projectFileSelectedList"
        :menu-config="menuData"
        @clickItem="changeMenu"
        :showMore="showMore"
        @showMoreDocument="showMoreDocument"
        @portfolioTabChange="handlePortfolioTabChange"
        :documentTypeMap="documentTypeMap"
      ></left-menu>
    </div>
    <div class="content">
      <div ref="content">
        <common-document
          @updateData="setMenuHeight"
          @updateMenu="updateMenu"
          :projectFileSelectedList="projectFileSelectedList"
          :projectId="projectId"
          :stage="stage"
          v-if="type === documentTypeMap.commonFile"
        ></common-document>
        <portfolio
          v-if="type === documentTypeMap.portfolioFile"
          :projectId="projectId"
          :time="key"
          :portfolioTabType="portfolioTabType"
          @updateData="setMenuHeight"
        ></portfolio>
        <group v-if="type === documentTypeMap.groupFile" @updateData="setMenuHeight" :projectId="projectId" :group-id="key"></group>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from './menu';
import Portfolio from './portfolio';
import CommonDocument from './commonDocument';
import Group from './groupDocument';
import { getCompanyFile } from '@/api/project';
import { quarterQuery } from '@/api/document.js';
import { feishuSourceList } from '@/api/companyGroup';
const documentTypeMap = {
  commonFile: 1,
  groupFile: 2,
  portfolioFile: 3
};

export default {
  components: {
    leftMenu: Menu,
    CommonDocument,
    Portfolio,
    Group
  },
  props: {
    projectId: {
      type: String,
      default: ''
    },
    stage: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      leftMenuStyle: '',
      docmentList: [],
      groupList: [],
      portfolioList: [],
      documentTypeMap,
      type: documentTypeMap.commonFile,
      key: '',
      projectFileSelectedList: [
        // {"fileTypeId":28,"fileSubtypeId":1},
        // {"fileTypeId":28}
      ],
      noPermissionList: [],
      emptyList: [],
      showMore: false,
      portfolioTabType: 'all' // 默认选项
    };
  },
  computed: {
    menuData() {
      let documentSum = this.docmentList.reduce((pre, current) => {
        return pre + current.count;
      }, 0);
      return [
        {
          text: '项目文档-全部',
          count: documentSum,
          type: documentTypeMap.commonFile,
          key: '',
          children: this.docmentList
        },
        {
          text: '飞书群同步资料',
          count: -1,
          type: documentTypeMap.groupFile,
          key: 2,
          disabled: true,
          tips: '1、会议群中的飞阅会文档已同步到上方项目文档中，这里只同步群中外链和图片。\n2、只有飞书群成员和项目DL/DM可见，其他人暂无权限（灰色)',
          children: this.groupList
        },
        {
          text: 'Portfolio作业',
          count: -1,
          type: documentTypeMap.portfolioFile,
          key: '',
          disabled: true,
          childrenTabs: [
            { label: '全部', value: 'all' },
            { label: '财务数据', value: 'finance' }
          ],
          currentTabLabel: this.portfolioTabType === 'all' ? '全部' : '财务数据',
          children: this.portfolioList
        }
      ];
    }
  },

  mounted() {
    this.setMenuHeight();
    this.initData();
    this.setMenuHeight.bind(this);
    window.addEventListener('resize', this.setMenuHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setMenuHeight);
  },
  methods: {
    setMenuHeight() {
      this.$nextTick(() => {
        let element = this.$refs.leftMenu;
        let actualTop = element.offsetTop;
        let current = element.offsetParent;
        while (current !== null) {
          actualTop += current.offsetTop;
          current = current.offsetParent;
        }
        // actualTop 为menu 距离页面顶端的距离
        let height = window.innerHeight - actualTop;
        if (height > this.$refs.content.offsetHeight) {
          this.leftMenuStyle = `height: ${height}px`;
        } else {
          this.leftMenuStyle = `height: ${this.$refs.content.offsetHeight}px`;
        }
      });
    },
    initData() {
      this.getCompanyFile();
      this.feishuSourceList();
      this.getPortfolioList();
    },
    changeMenu(item, subitem) {
      // item.type 1-项目文件 2-飞书群 3-portfolio
      if (item.type === 1) {
        // 如果已选中就取消,如果没有就选中
        // 如果选中的有子元素,且子元素没有全都被选中,就选中所有的子元素
        // 如果选中的有子元素,且子元素都被选中,就取消选中所有的子元素
        // 如果选中全部,则清空所有(?)
        this.type = item.type;
        // 点了全部
        if (item.key === '') {
          // console.log('all');
          this.projectFileSelectedList = [];
        } else if (item.count === -1 && !this.projectFileSelectedList.find(_ => _.key === item.key)) {
          let tmp = this.projectFileSelectedList.find(_ => _.fileTypeId === item.key);
          if (tmp) {
            this.projectFileSelectedList = [];
          } else {
            this.projectFileSelectedList = [{ fileTypeId: item.key }];
          }
        }
        // 点了[财务文件]
        else if (item.children && !subitem) {
          // 选中全部子元素
          if (item.children.some(e => !this.projectFileSelectedList.find(_ => _.fileTypeId === item.key && _.fileSubtypeId === e.key))) {
            this.projectFileSelectedList = this.projectFileSelectedList
              .filter(_ => _.fileTypeId !== item.key)
              .concat(
                item.children.map(_ => {
                  return {
                    fileTypeId: item.key,
                    fileSubtypeId: _.key
                  };
                })
              );
          }
          // 取消选中所有子元素
          else {
            // console.log('2');
            this.projectFileSelectedList = this.projectFileSelectedList.filter(_ => _.fileTypeId !== item.key);
          }
        }
        // 点了财务文件的子类型
        else if (subitem) {
          let tmp = this.projectFileSelectedList.find(_ => _.fileTypeId === item.key && _.fileSubtypeId === subitem.key);
          if (tmp) {
            this.projectFileSelectedList = this.projectFileSelectedList.filter(_ => !(_.fileTypeId === item.key && _.fileSubtypeId === subitem.key));
          } else {
            this.projectFileSelectedList.push({ fileTypeId: item.key, fileSubtypeId: subitem.key });
          }
        }
        // 点了其他类型
        else {
          let tmp = this.projectFileSelectedList.find(_ => _.fileTypeId === item.key);
          if (tmp) {
            this.projectFileSelectedList = this.projectFileSelectedList.filter(_ => _.fileTypeId !== item.key);
          } else {
            this.projectFileSelectedList.push({ fileTypeId: item.key });
          }
        }
        // this.projectFileSelectedList = [];
      } else {
        this.key = item.key;
        this.type = item.type;
        this.projectFileSelectedList = [];
      }
    },

    showMoreDocument(val) {
      if (val) {
        if (this.noPermissionList.length > 0) {
          this.docmentList = this.docmentList.concat(this.noPermissionList.slice(1));
        }
        this.docmentList = this.docmentList.concat(this.emptyList);
      } else {
        this.docmentList = this.docmentList.filter(_ => _.count > 0);
        if (this.noPermissionList.length > 0) {
          this.docmentList.push(this.noPermissionList[0]);
        }
      }
    },

    feishuSourceList() {
      feishuSourceList({ companyId: this.projectId }).then(res => {
        if (res.code === 200) {
          this.groupList = res.data.map(i => {
            return {
              text: i.name,
              count: i.docCount,
              key: i.groupId,
              disabled: i.canView === -1,
              type: documentTypeMap.groupFile,
              icon: 'team',
              tips: i.canView === -1 ? '抱歉，您暂无权限查看，请找该飞书群主申请入群后即可查看' : ''
            };
          });
        }
      });
    },
    updateMenu(type = '') {
      if (type === 'reset') {
        this.projectFileSelectedList = [];
      }
      this.getCompanyFile();
    },
    getCompanyFile() {
      getCompanyFile({
        companyId: this.projectId
      }).then(res => {
        if (res.code === 200) {
          let { fileTypes, fileTypeCount } = res.data;
          // this.
          let list = fileTypes.map(i => {
            return {
              text: i.name,
              count: fileTypeCount[i.id] || i.count,
              key: i.id,
              icon: 'file',
              type: documentTypeMap.commonFile,
              children: i.childFiletypes
                ? i.childFiletypes.map(j => {
                  return {
                    text: j.name,
                    count: j.count,
                    key: j.id,
                    icon: 'file',
                    type: documentTypeMap.commonFile
                  };
                })
                : null
            };
          });
          this.docmentList = list.filter(_ => {
            return _.count > 0;
          });
          this.noPermissionList = list.filter(_ => {
            return _.count === -1;
          });
          this.emptyList = list.filter(_ => {
            return _.count === 0;
          });
          if (this.noPermissionList.length > 0) {
            this.docmentList.push(this.noPermissionList[0]);
            // this.noPermissionList.shift();
          }
          if (this.emptyList.length > 0 || this.noPermissionList.length > 0) {
            this.showMore = true;
          }
          // console.log('this.docmentList', this.docmentList);
        }
      });
    },
    getPortfolioList() {
      quarterQuery({
        companyId: this.projectId
      }).then(res => {
        if (res.code === 200) {
          this.portfolioList = res.data.map(i => {
            return {
              text: i.quarter === 5 ? `${i.year}年年度` : `${i.year}年Q${i.quarter}`,
              count: -1,
              key: `${i.year}-${i.quarter}`,
              type: documentTypeMap.portfolioFile,
              icon: 'file'
            };
          });
        }
      });
    },
    // getFilteredPortfolioList(type) {
    //   if (type === 'finance') {
    //     return this.portfolioList.filter(item => item.category === 'finance');
    //   }
    //   return this.portfolioList;
    // },

    handlePortfolioTabChange(newType) {
      this.portfolioTabType = newType;
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  display: flex;
}
.left-menu {
  flex: none;
  overflow: auto;
}
.content {
  flex: auto;
}
</style>
